export const catalogsSyncTypes = {
  SYNC_CATALOGS_SYNC: 'SYNC_CATALOGS_SYNC',
  CLEAR_CATALOGS_SYNC: 'CLEAR_CATALOGS_SYNC',
}